import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingHealthcareComponent } from './landing-healthcare.component';
import { HealthcareRoutingModule } from './healthcare-routing.module';
// import { SharedModule } from 'src/app/shared/shared.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
    declarations: [
        LandingHealthcareComponent
    ],
    imports: [
        HealthcareRoutingModule, CommonModule, SharedModule
    ],
    exports: [LandingHealthcareComponent]
})
export class HealthcareModule { }
